import { connect } from 'react-redux';
import { withTemplates } from 'hocs';
import { notificationActions } from '../../../../../components/notifications/actions/notification';
import { hasFeature } from '../../../../shared/featureFlag';
import { Templates as TemplatesImpl, } from '../../../components/sections/templates';
const mapStateToProps = (state) => ({
    hasLanguageTranslationControlFF: hasFeature(state, 'templates-language-translation-control'),
});
const mapDispatchToProps = (dispatch) => ({
    notificationAdd: (payload) => dispatch(notificationActions.notificationAdd(payload)),
});
const Templates = withTemplates(TemplatesImpl, {
    initialParams: { sort_by: 'name:asc' },
});
export default connect(mapStateToProps, mapDispatchToProps)(Templates);
